module.exports = __webpack_public_path__ + "img/11d.2a658fc8.svg";